
import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { companyInfo } from "./menuconfig";

const Footer = () => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000); // updates every second
    return () => clearInterval(timer); // cleanup
  }, []);

  return (
    <footer className="bg-dark text-white py-3 mt-auto">
      <Container>
        <Row className="text-center text-md-start">
          <Col xs={12} md={4} className="mb-3 mb-md-0">
            <h5 className="fw-bold">{companyInfo.name}</h5>
            <p className="mb-0">{companyInfo.address}</p>
            {/* <p><a href="mailto:info@finglider.com" className="text-white">info@finglider.com</a></p> */}
          </Col>

          <Col xs={12} md={4} className="mb-3 mb-md-0 d-flex align-items-center justify-content-center">
            <div className="text-center">
              <p className="mb-2">
                {currentDateTime.toLocaleDateString('en-US', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
              <p className="mb-0">
                {currentDateTime.toLocaleTimeString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                })}
              </p>
            </div>
          </Col>

          <Col xs={12} md={4} className="d-flex align-items-center justify-content-center justify-content-md-end">
            <div className="text-md-end">
              <p className="mb-0">&copy; {new Date().getFullYear()} FinGlider. All Rights Reserved.</p>
              <p className="mb-0">Where Innovation Meets Expertise</p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
